import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const SearchHitInfoBoxListingLabelsHolder = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  margin: 15px 0 10px;
`;

export const SearchHitInfoBoxListingLabelsPillContainer = styled.div`
  margin-bottom: 10px;
`;

export const SearchHitInfoBoxListingLabelsPill = styled.span`
  height: 20px;
  border: solid 1px;
  border: solid 1px ${colors.elementGrey};
  border-radius: 12px;
  padding: 4px 8px;
  color: ${colors.black};
  font-size: 12px;
  margin-right: 8px;
`;
